/* <face-details> — per-variant "engraved face details" card (variant-specs).
   Markup is rendered server-side by snippets/obverse-reverse-section.liquid.
   This element only drives the Obverse/Reverse toggle: it slides the thumb,
   swaps the visible face group, and keeps the thumb aligned when the block is
   shown by the variant picker (each variant has its own instance; only the
   selected one is visible). */
class FaceDetails extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.toggle = this.querySelector('.face-details__toggle');
    this.btns = Array.prototype.slice.call(this.querySelectorAll('.face-details__toggle button'));
    this.thumb = this.querySelector('.face-details__thumb');
    this.faces = Array.prototype.slice.call(this.querySelectorAll('.face-details__face'));
    if (!this.btns.length) return;            // no face data -> nothing to drive
    this.face = 'obverse';

    var self = this;
    this.btns.forEach(function (b) {
      b.addEventListener('click', function () { self.setFace(b.dataset.face); });
    });
    this.toggle.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      self.setFace(self.face === 'obverse' ? 'reverse' : 'obverse', true);
    });

    // the thumb needs the toggle laid out; for hidden variants offsetWidth is 0
    // until the picker reveals the block, so re-measure on any size change.
    if ('ResizeObserver' in window) {
      this._ro = new ResizeObserver(function () { self.positionThumb(); });
      this._ro.observe(this);
    } else {
      this._onResize = function () { self.positionThumb(); };
      addEventListener('resize', this._onResize);
    }
    addEventListener('load', function () { self.positionThumb(); });
    this.positionThumb();
    requestAnimationFrame(function () { self.positionThumb(); });
  }

  disconnectedCallback() {
    if (this._ro) this._ro.disconnect();
    if (this._onResize) removeEventListener('resize', this._onResize);
  }

  positionThumb() {
    if (!this.thumb || !this.btns.length) return;
    var b = this.btns.find(function (x) { return x.getAttribute('aria-selected') === 'true'; }) || this.btns[0];
    if (!b.offsetWidth) return;               // not laid out yet (hidden)
    this.thumb.style.width = b.offsetWidth + 'px';
    this.thumb.style.transform = 'translateX(' + b.offsetLeft + 'px)';
  }

  setFace(face, focus) {
    if (!face || face === this.face) return;
    this.face = face;
    this.btns.forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.face === face ? 'true' : 'false');
    });
    this.positionThumb();
    this.swapFaces();
    if (focus) {
      var b = this.btns.find(function (x) { return x.dataset.face === face; });
      if (b) b.focus();
    }
  }

  swapFaces() {
    if (!this.faces.length) return;
    var self = this;
    var next = this.faces.find(function (f) { return f.dataset.face === self.face; });
    if (!next) return;
    var current = this.faces.find(function (f) { return !f.hidden && f !== next; });
    if (current) {
      current.classList.add('is-swap');
      clearTimeout(this._swap);
      this._swap = setTimeout(function () {
        current.hidden = true;
        current.classList.remove('is-swap');
        self.reveal(next, false);
      }, 150);
    } else {
      this.faces.forEach(function (f) { if (f !== next) { f.hidden = true; f.classList.remove('is-swap'); } });
      this.reveal(next, true);
    }
  }

  reveal(face, instant) {
    face.hidden = false;
    if (instant) { face.classList.remove('is-swap'); return; }
    face.classList.add('is-swap');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { face.classList.remove('is-swap'); });
    });
  }
}
customElements.define('face-details', FaceDetails);
